import ConfirmModal from '@/components/ConfirmModal';
import { abandonExchange } from '@/features/purchase/purchaseActions';
import { useSearchWidget } from '@/hooks/useSearchWidget';
import { TransText } from '@/i18n/trans/text';
import { persistor } from '@/store';
import { useDispatch } from '@/store/utils';
import { breakpoints } from '@/utils/breakpoints';
import { Button, Icons, Typography } from '@fleet/webshop-ui';
import { type FC, useCallback } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';

// Change-booking replacement for CancelPurchaseButton: cancels the BE
// exchange operation (silent on already-confirmed ops) + resets purchase +
// change-trips state via `abandonExchange`, then purges the persisted store
// and returns to manage.
const CancelExchangeButton: FC = () => {
  const dispatch = useDispatch();
  const { setCurrentSearchFormValues } = useSearchWidget();
  const isLaptopOrBigger = useMediaQuery({
    minWidth: breakpoints.laptop,
  });
  const navigate = useNavigate();

  const handleCancel = useCallback(async () => {
    await dispatch(abandonExchange());
    setCurrentSearchFormValues(undefined);
    void persistor.purge();
    navigate('/manage-booking/details');
  }, [dispatch, navigate, setCurrentSearchFormValues]);

  return (
    <ConfirmModal
      title={<TransText i18nKey="cancelChange" />}
      description={
        <Typography variant="paragraph">
          <TransText i18nKey="cancelChangeConfirmation" />
        </Typography>
      }
      cancelLabel="dismiss"
      confirmLabel="confirm"
      onConfirm={handleCancel}
    >
      <Button
        size={isLaptopOrBigger ? 'medium' : 'large'}
        data-testid="cancel-exchange-button"
        className="rounded-lg laptop:w-auto"
        variant="tertiary"
        startAdornment={<Icons.cancel />}
      >
        <TransText i18nKey="cancel" />
      </Button>
    </ConfirmModal>
  );
};

export default CancelExchangeButton;
